import { useContext } from 'react';

import _get from 'lodash/get';
import noop from 'lodash/noop';

import { EMPTY_OBJECT, AppContext } from 'commons-ui';
import useService from '../utils/useService';
import { GAME_KEY_MAP } from '../utils/helper';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData = EMPTY_OBJECT, setConfirmationDialog } = params;
	const { updateZKUpdateReq } = useService();
	const { app, showAlert } = useContext(AppContext);
	switch (action.id) {
		case 'getKeys':
			return () => {
				const { id } = rowData;

				history.push({
					pathname: '/gameAdmin/zkPreProd/keys',
					state: {
						keysData: {
							serviceName: id
						}
					}
				});
			};
		case 'getAllPendingZkUpdateReqs':
			return () => {
				const { id } = rowData;

				history.push({
					pathname: '/gameAdmin/zkPreProd/getAllPendingZkUpdateReqs/',
					state: {
						keysData: {
							serviceName: id
						}
					}
				});
			};
		case 'approveUpdateReq': {
			const { id, serviceName } = rowData;
			const game = GAME_KEY_MAP[app.appName];
			const approveUpdateReq = async () => {
				const res = await updateZKUpdateReq({
					serviceName,
					game,
					reqId: id,
					action: 'APPROVED'
				});
				if (res?.success && !res?.isError) {
					showAlert('Key Update was Successful', {
						type: 'success',
						duration: 'INFINITE',
						actionMessage: 'OK',
						actionOnClick: () => {
							history.goBack();
						}
					});
				} else {
					showAlert(`Key Update Failed. ${res.message}`, {
						type: 'error',
						actionMessage: 'OK',
						actionOnClick: () => {
							history.goBack();
						}
					});
				}
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Approve the change?',
					handleAlertConfirmation: approveUpdateReq
				});
			};
		}

		case 'rejectUpdateReq': {
			const { id, serviceName } = rowData;
			const game = GAME_KEY_MAP[app];
			const approveUpdateReq = async () => {
				const res = await updateZKUpdateReq({
					serviceName,
					game,
					reqId: id,
					action: 'REJECTED'
				});
				if (res?.success) {
					showAlert('Key Reject was Successful', {
						type: 'success',
						duration: 'INFINITE',
						actionMessage: 'OK',
						actionOnClick: () => {
							history.goBack();
						}
					});
				} else {
					showAlert(`Key Reject Failed. ${res.message}`, {
						type: 'error',
						actionMessage: 'OK',
						actionOnClick: () => {
							history.goBack();
						}
					});
				}
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Reject the change?',
					handleAlertConfirmation: approveUpdateReq
				});
			};
		}

		case 'viewKey':
			return () => {
				const { id, serviceName } = rowData;
				history.push({
					pathname: '/gameAdmin/zkPreProd/edit',
					state: {
						keysData: {
							serviceName,
							keyName: id
						}
					}
				});
			};
		case 'addKey':
			return () => {
				const { serviceName } = _get(params, 'location.state.keysData', {});
				history.push({
					pathname: '/gameAdmin/zkPreProd/add',
					state: {
						keysData: {
							serviceName
						}
					}
				});
			};

		default:
			return noop;
	}
};

export default {
	makeActionHandler
};
